import { render } from "./SiteFooter.vue?vue&type=template&id=0f92714d&scoped=true&ts=true"
import script from "./SiteFooter.vue?vue&type=script&lang=ts"
export * from "./SiteFooter.vue?vue&type=script&lang=ts"

import "./SiteFooter.vue?vue&type=style&index=0&id=0f92714d&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f92714d"]])

export default __exports__